<ng-container *transloco="let convert;">
  <section class="inventory-item-card mt-2 border border-dark">
    <div class="inventory-item-card__wrapper d-flex px-2 px-md-3 pt-3">
      <a
        class="inventory-item-card__image-wrap me-2"
        data-track-elem="button"
        data-track-name="Vehicle Image"
        routerLink="details"
        >
        <ng-content *ngTemplateOutlet="imagePlaceholder"></ng-content>
      </a>

      <div class="inventory-item-card__content">
        <div class="inventory-item-card__header pt-0">
          <header class="inventory-item-card__header-info">
            <div class="inventory-item-card__header-title">
              <a
                class="h5 inventory-item-card__title text-primary"
                routerLink="details"
                [attr.aria-label]="title + convert('sellModule.inventoryItem.inventoryItemCard.ariaLabelVehicleDetail')"
                data-track-elem="card id"
                [attr.data-track-name]="inventoryItem?.inventoryItemUuid"
                >
                <span id="inventory_card_year">{{ detail('modelYear') }} </span>
                <span id="inventory_card_make">{{ detail('make') }} </span>
                <span id="inventory_card_model">{{ detail('model') }} </span>
                <span id="inventory_card_trim">{{ detail('trim') }} </span>
                <span id="inventory_card_drivetrain_abbrev">{{ driveTrain }}</span>
              </a>
            </div>
            <div class="card-header-data-container">
              <span class="full-screen-inline">
                <div id="inventory_card_vin" class="inventory-item-card__vin me-4">
                  {{ (inventoryItem?.itemDetail?.vin ? inventoryItem.itemDetail.vin : '') | uppercase }}
                </div>
              </span>
              <span class="mobile-data-row full-screen-inline full-width">
                <span id="inventory_card_stock_number" class="inventory-item-card__stock-number me-4">
                  <span class="title">{{convert('sellModule.inventoryItem.inventoryItemCard.textStockUnit')}}</span>
                  <span>
                    {{ (auctionItem?.stockNumber ? auctionItem.stockNumber : 'N/A') | uppercase }}
                  </span>
                </span>
                @if (isInspectionSeriesEnabled) {
                  <span id="inventory_card_inspection_series" class="inventory-item-card__stock-number right-align">
                    <span class="title">{{translations.inspectionSeriesLabelText}}</span>
                    <span>
                      {{ (auctionItem?.inspectionSeries?.length > 0 ? auctionItem.inspectionSeries : 'N/A') | uppercase }}
                    </span>
                  </span>
                }
              </span>
            </div>
          </header>
        </div>

        <!-- desktop details -->
        @if (!collapsed) {
          <div class="inventory-item-card__details justify-content-between pt-2 d-none d-md-flex">
            <ng-content *ngTemplateOutlet="seller"></ng-content>
            <ng-content *ngTemplateOutlet="odometer"></ng-content>
            <ng-content *ngTemplateOutlet="hits"></ng-content>
            <ng-content *ngTemplateOutlet="average"></ng-content>
            @if (isAuctionItemActive) {
              <ng-content *ngTemplateOutlet="daysRemaining"></ng-content>
            }
            <ng-content *ngTemplateOutlet="tenantBadge"></ng-content>
          </div>
        }
      </div>
    </div>

    <!-- mobile details -->
    @if (!collapsed) {
      <div class="inventory-item-card__details justify-content-between pt-0 d-md-none px-2">
        <div class="row tab-mobile" role="presentation">
          <div class="col"><ng-content *ngTemplateOutlet="seller"></ng-content></div>
          <div class="col"><ng-content *ngTemplateOutlet="average"></ng-content></div>
        </div>
        <div class="row tab-mobile" role="presentation">
          <div class="col"><ng-content *ngTemplateOutlet="odometer"></ng-content></div>
          <div class="col"><ng-content *ngTemplateOutlet="daysRemaining"></ng-content></div>
        </div>
        <div class="row tab-mobile" role="presentation">
          <div class="col"><ng-content *ngTemplateOutlet="hits"></ng-content></div>
          <div class="col"><ng-content *ngTemplateOutlet="tenantBadge"></ng-content></div>
        </div>
      </div>
    }
    <!-- footer -->
    <div class="inventory-item-card__footer mt-2">
      <div class="inventory-item-card__footer-wrapper d-flex align-items-center p-2 py-md-3">
        <div class="d-flex align-items-center date">
          @if (showAuctionEndTime) {
            <i class="allycon-clock me-2 clock" aria-hidden="true"></i>
          }
          @if (showAuctionStartTime || showAuctionExtendTime) {
            <i
              class="allycon-sm-calendar me-2 clock"
              aria-hidden="true"
            ></i>
          }
          <span class="time">
            @if (isAuctionItemActive) {
              <span class="time__label me-2 d-none d-md-inline">
                @if (showAuctionStartTime) {
                  <strong>{{convert('sellModule.inventoryItem.inventoryItemCard.textStartDate')}}</strong>
                }
                @if (showAuctionEndTime || showAuctionExtendTime) {
                  <strong>{{convert('sellModule.inventoryItem.inventoryItemCard.textEndDate')}}</strong>
                }
              </span>
            }
            @if (showAuctionStartTime) {
              <span id="inventory_card_start_time" class="time__content">{{
                auctionStartTime
              }}</span>
            }
            @if (showAuctionExtendTime) {
              <span id="inventory_card_extend_time" class="time__content">{{
                auctionExtendedTime
              }}</span>
            }
            @if (showAuctionEndTime) {
              <span id="inventory_card_end_time" class="time__content">{{
                auctionEndTime
              }}</span>
            }
          </span>
        </div>
        <div class="divider px-3">&#124;</div>
        @if (isAuctionItemActive && !auctionItem?.openingPrice) {
          <div class="d-flex align-items-center">
            <div class="fw-bold">{{ bidStatus }}</div>
            <div class="divider px-3">&#124;</div>
          </div>
        }
        @if (isAuctionItemActive) {
          <app-datalist-item
            [identifier]="auctionItem?.openingPrice ? 'inventory_card_opening_price' : 'inventory_card_current_bid'"
            [label]="auctionItem?.openingPrice ? convert('sellModule.inventoryItem.inventoryItemCard.labelOpeningPrice') : convert('sellModule.inventoryItem.inventoryItemCard.labelCurrentBid')"
            value="{{ formatCurrency(auctionItem?.currentAmount) }}"
          ></app-datalist-item>
        }
        @if (!isAuctionItemActive) {
          <div
        [ngClass]="{
          'sold-status': auctionItem?.auctionItemStatus === 'SOLD',
          'fw-bold': auctionItem?.auctionItemStatus !== 'SOLD'
        }"
            >
            {{ auctionItem?.auctionItemStatus | titlecase }}
          </div>
        }
        @if (isAuctionItemActive) {
          <div class="divider px-3 d-none d-md-flex">&#124;</div>
        }
        @if (isAuctionItemActive) {
          <app-datalist-item
            identifier="inventory_card_buy_now_price"
            class="d-none d-md-flex"
            label="{{ convert('common.labelBuyNowPrice') }}"
            [value]="auctionItem?.buyNowEligible ? formatCurrency(auctionItem?.buyNowAmount) : 'N/A'"
          ></app-datalist-item>
        }

        @if (auctionItem && auctionItem.auctionItemStatus === 'SOLD') {
          <div class="divider px-3">&#124;</div>
          <app-datalist-item
            identifier="inventory_card_sale_price"
            label="{{convert('sellModule.inventoryItem.inventoryItemCard.labelSalePrice')}}"
            value="{{ auctionItem?.salePrice | currency: 'USD':'symbol':'1.0-0' }}"
          ></app-datalist-item>
        }
      </div>
      @if (isAuctionItemActive) {
        <div
          class="inventory-item-card__footer_buy-now-container pt-1 py-2 px-2 d-block d-md-none"
          >
          <app-datalist-item
            identifier="inventory_card_buy_now_price"
            label="{{convert('common.labelBuyNowPrice')}}"
            [value]="auctionItem?.buyNowEligible ? formatCurrency(auctionItem?.buyNowAmount) : 'N/A'"
          ></app-datalist-item>
        </div>
      }
    </div>

    <collapse-card (collapse)="toggleCollapseCard($event)" [collapsed]="collapsed"></collapse-card>
  </section>

  <ng-template #location>
    <app-datalist-item
      identifier="inventory_card_location"
      label="{{convert('sellModule.inventoryItem.inventoryItemCard.labelLocation')}}"
    [value]="
      get('storageLocation.state', false) && get('storageLocation.city', false)
        ? get('storageLocation.city', false) + ', ' + get('storageLocation.state', false)
        : 'N/A'
    "
    ></app-datalist-item>
  </ng-template>
  <ng-template #hits>
    <app-datalist-item identifier="inventory_card_hits" label="{{convert('sellModule.inventoryItem.inventoryItemCard.labelHits')}}" [value]="viewCount()"></app-datalist-item>
  </ng-template>
  <ng-template #odometer>
    <app-datalist-item identifier="inventory_card_odometer" label="{{convert('sellModule.inventoryItem.inventoryItemCard.labelOdometer')}}" [value]="odometerDisplay"></app-datalist-item>
  </ng-template>
  <ng-template #average>
    <app-datalist-item
      identifier="inventory_card_bookvalue"
      label="{{ bookProvider | uppercase }}"
      value="{{ getSpreadToBookValue() ? formatCurrency(getSpreadToBookValue()) : 'N/A' }}"
    ></app-datalist-item>
  </ng-template>
  <ng-template #daysRemaining>
    <app-datalist-item
      identifier="inventory_card_days_remaining"
      label="{{convert('sellModule.inventoryItem.inventoryItemCard.labelDaysRemaining')}}"
      [value]="daysRemainingAuction()"
    ></app-datalist-item>
  </ng-template>
  <ng-template #tenantBadge>
    @if (isTenantBadgeEnabled) {
      <app-datalist-item
        identifier="inventory_card_tenant_badge"
        label="{{convert('sellModule.inventoryItem.inventoryItemCard.labelTenantBadge')}}"
        [value]="tenantBadgeName()"
      ></app-datalist-item>
    }
  </ng-template>

  <ng-template #imagePlaceholder>
    <lib-images-count [img]="inventoryItem?.itemDetail?.image" [count]="auctionItem?.imageCount"></lib-images-count>
  </ng-template>

  <ng-template #seller>
    @if (!isMobile && sellerName().length > 45) {
      <app-datalist-item
        identifier="inventory_card_seller"
        label="{{convert('sellModule.inventoryItem.inventoryItemCard.labelSeller')}}"
        >
        <app-tooltip [tooltip]="{body: sellerName()}" triggers="click hover :keydown.escape :keydown.tab">
          {{sellerName().substr(0, 45) }}...
        </app-tooltip>
      </app-datalist-item>
    }

    @if (isMobile && sellerName().length > 20) {
      <app-datalist-item
        identifier="inventory_card_seller"
        label="{{convert('sellModule.inventoryItem.inventoryItemCard.labelSeller')}}"
        >
        <app-tooltip [tooltip]="{body: sellerName()}" triggers="click hover :keydown.escape :keydown.tab">
          {{sellerName().substr(0, 20) }}...
        </app-tooltip>
      </app-datalist-item>
    }

    @if (!isMobile && sellerName().length <= 45) {
      <app-datalist-item
        identifier="inventory_card_seller"
        label="{{convert('sellModule.inventoryItem.inventoryItemCard.labelSeller')}}"
        [value]="sellerName()"
      ></app-datalist-item>
    }

    @if (isMobile && sellerName().length <= 20) {
      <app-datalist-item
        identifier="inventory_card_seller"
        label="{{convert('sellModule.inventoryItem.inventoryItemCard.labelSeller')}}"
        [value]="sellerName()"
      ></app-datalist-item>
    }


  </ng-template>
</ng-container>
